import { motion } from "framer-motion";

export const ChapterCover = ({ id, part, title, value, note, color }) => (
  <section id={id} data-testid={`chapter-${id}`} className="flex min-h-[80vh] items-center scroll-mt-14 text-white" style={{ background: color }}>
    <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.4 }} transition={{ duration: 0.8 }} className="mx-auto w-full max-w-6xl px-5 py-20">
      <p className="text-sm font-black tracking-[0.4em] text-white/70">PART {part}</p>
      <h2 className="mt-4 text-6xl font-black md:text-9xl">{title}</h2>
      <p className="mt-6 text-2xl font-black md:text-4xl">{value}</p>
      <p className="mt-2 text-sm font-bold text-white/80 md:text-base">{note}</p>
    </motion.div>
  </section>
);
